import React from 'react'
import classNames from 'classnames'
import { IncreaseLoanAmountBannerBase } from '@/components/banners/IncreaseLoanAmountBannerBase'
import { messages } from './messages'
import type { IIncreaseLoanAmountBannerAccentProps } from './types'
import './styles.scss'

export const IncreaseLoanAmountBannerAccent: React.FC<IIncreaseLoanAmountBannerAccentProps> = ({ className, comment }) => {
  return (
    <IncreaseLoanAmountBannerBase
      className={classNames('increaseLoanAmountBannerAccent', className)}
      title={messages.title}
      buttonText={messages.action}
      buttonModifiers={['green']}
      actionClassName="increaseLoanAmountBannerAccent__action"
      subtitleClassName="increaseLoanAmountBannerAccent__subtitle"
      comment={comment}
    />
  )
}
